<template>
    <!-- <h1>error</h1> -->
    <div class="error">
    <el-empty description="找不到内容" />
    <div class="back"><a href="/">&lt;&lt;返回</a></div>
    </div>
</template>

<script>
    export default {
        name: "error"
    }
</script>

<style scoped>
    .error{
        height: 75vh;
    }
.back{text-align: center;}
.back a{color:#f90;}
</style>
